export default "__VITE_ASSET__BLLw7djf__"